import { render } from "./TodoFooter.vue?vue&type=template&id=60ace40b&scoped=true"
import script from "./TodoFooter.vue?vue&type=script&lang=js"
export * from "./TodoFooter.vue?vue&type=script&lang=js"

import "./TodoFooter.vue?vue&type=style&index=0&id=60ace40b&scoped=true&lang=css"

import exportComponent from "/home/bammer/vue/doit-vue/vue-todo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60ace40b"]])

export default __exports__